const drivingtests = {
	title: "Driving Tests",
	new_drivingtest: "New Driving Test",
	edit_drivingtest: "Edit Driving Test",
	view_drivingtest: "View Driving Test",
	list_title: "List of Driving Tests",
	list_subtitle: "Manage Driving Test",
	create_title: "Create New Driving Test",
	update_title: "Update Driving Test",
	address_title: "Address",
	details_title: "Driving Test Details",
	id: "ID",
	enrolled_organisation_id: "Organisation",
	participant_id: "Participant",
	coursetypegroup_id: "Course Type Group",
	coursetype_id: "Course Type",
	course_id: "Course",
	description: "Description",
	place: "Place",
	status: "Status",
	instructor_id: "Instructor",
	class_id: "Class",
	date: "Date",
	time: "Time",
};
export default drivingtests;